import * as React from 'react';
import { SliderView } from 'elc-slider';
import { classes } from '../../utils/Classes';
import { ShadeInfo } from './ShadeInfo';
import { StyledCircleIcon, ShadePickerSlider } from './ShadePickerCarouselStyles';
import { IShadePickerCarousel } from '../../interfaces/IShadePicker';
import { ShadeImagesList } from './ShadeImages';

export const ShadeIcon = ({ hexValue }: { hexValue: string }) => (
    <StyledCircleIcon color={hexValue} />
);

export const ShadePickerCarousel = (props: IShadePickerCarousel) => {
    const getShadeInfo = () => {
        const { shadeDescriptionPosition, shadeNamePosition, separator, selectedShade } = props;

        return (
            <ShadeInfo
                selectedShade={selectedShade}
                separator={separator}
                shadeDescriptionPosition={shadeDescriptionPosition}
                shadeNamePosition={shadeNamePosition}
            />
        );
    };

    const {
        shadeInfoAbovePicker,
        shadeInfoBelowPicker,
        sliderSettings,
        filteredShades,
        shadeConfig
    } = props;

    const shadeImages = ShadeImagesList({ filteredShades, shadeConfig });
    const shadePickerSliderClassNames = classes('product-shade-picker-slider');

    return (
        <ShadePickerSlider>
            {shadeInfoAbovePicker && getShadeInfo()}
            <SliderView
                className={shadePickerSliderClassNames}
                sliderSettings={sliderSettings}
                items={shadeImages}
            />
            {shadeInfoBelowPicker && getShadeInfo()}
        </ShadePickerSlider>
    );
};
